import {RecordKind} from '../const';

export function hasType({type}: RecordEntry, kind: RecordEntryKind): boolean {
  return type === kind;
}

export const isSpend = (record: RecordEntry): boolean => hasType(record, RecordKind.Spend);
